export default "__VITE_ASSET__DFzRkeZ8__"